module.exports = __webpack_public_path__ + "static/img/m75bb.2d23763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/m75bb.jpg
// module id = +jTV
// module chunks = 0